import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'
import queryString from 'query-string'
import { TTableResponse } from '../../shared/types/TableResponse.type'
import { ICommonResponse } from '../../shared/interfaces/CommonResponse.interface'

export const affiliateRuleApi = createApi({
  reducerPath: 'affiliate-rule/api',
  tagTypes: ['AffiliateRule'],
  baseQuery: fetchBaseQuery({
    baseUrl: '/affiliate-rule/',
    paramsSerializer: (params) => queryString.stringify(params),
  }),
  endpoints: (build) => ({
    getAffiliateRule: build.query<TTableResponse<any>, any>({
      query: (params: any) => ({
        url: 'list',
        params,
      }),
      providesTags: ['AffiliateRule'],
    }),
    create: build.mutation<ICommonResponse<any>, any>({
      query: ({ projectId, url, domainZones, params }: any) => ({
        url: 'create',
        method: 'POST',
        body: (() => {
          const formData = new FormData()
          formData.append('scenario', 'create')
          formData.append('project_id', projectId)
          formData.append('url', url)
          formData.append('domain_zones', JSON.stringify(domainZones))
          formData.append('params', JSON.stringify(params))
          formData.append('enabled', JSON.stringify(true))
          return formData
        })(),
        cache: 'no-cache',
      }),
      invalidatesTags: ['AffiliateRule'],
    }),
    updateStatus: build.mutation<ICommonResponse<any>, any>({
      query: ({ id, enabled }: any) => ({
        url: 'update',
        method: 'POST',
        body: (() => {
          const formData = new FormData()
          formData.append('scenario', 'update_status')
          formData.append('id', id)
          formData.append('enabled', enabled)
          return formData
        })(),
        cache: 'no-cache',
      }),
      invalidatesTags: ['AffiliateRule'],
    }),
    updateDomains: build.mutation<ICommonResponse<any>, any>({
      query: ({ id, domainZones }: any) => ({
        url: 'update',
        method: 'POST',
        body: (() => {
          const formData = new FormData()
          formData.append('scenario', 'update_zones')
          formData.append('id', id)
          formData.append('domain_zones', JSON.stringify(domainZones))
          return formData
        })(),
        cache: 'no-cache',
      }),
      invalidatesTags: ['AffiliateRule'],
    }),
    updateParams: build.mutation<ICommonResponse<any>, any>({
      query: ({ id, params }: any) => ({
        url: 'update',
        method: 'POST',
        body: (() => {
          const formData = new FormData()
          formData.append('scenario', 'update_params')
          formData.append('id', id)
          formData.append('params', JSON.stringify(params))
          return formData
        })(),
        cache: 'no-cache',
      }),
      invalidatesTags: ['AffiliateRule'],
    }),
  }),
})

export const {
  useGetAffiliateRuleQuery,
  useCreateMutation,
  useUpdateStatusMutation,
  useUpdateDomainsMutation,
  useUpdateParamsMutation,
} = affiliateRuleApi
